module.exports = __webpack_public_path__ + "img/Automated.738b837c.svg";